import React, {useState} from 'react';
import {Tooltip, Typography} from "@material-tailwind/react";

const TableTdContent = ({content, length}) => {

  const [len, setLen] = useState(parseInt(length) || 20);

  const isOverflowing = (text) => {
    return text?.length > length; // Adjust the threshold as needed
  };

  const displayContent = isOverflowing(content) ? `${content.substring(0, length - 3)}...` : content


  return (
    <div className="flex justify-center px-4 max-w-full max-h-full"
         style={{whiteSpace: 'nowrap'}}
    >
      {content?.length > 0 && isOverflowing(content) ? (
        <Tooltip content={content}>
          <Typography color="blue-gray" className="textRight">
            {displayContent}
          </Typography>
        </Tooltip>
      ) : (
        <Typography color="blue-gray" className="textRight">
          {displayContent}
        </Typography>
      )}
    </div>
  );
};

export default TableTdContent;
